"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBox = exports.PRODUCT_BOX_STYLE_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductBoxList = require("./ProductBoxList");
var _ProductBoxTable = require("./ProductBoxTable");
var _ProductBoxTile = require("./ProductBoxTile");
require("./ProductBox.scss");
var PRODUCT_BOX_STYLE_TYPE = /*#__PURE__*/function (PRODUCT_BOX_STYLE_TYPE) {
  PRODUCT_BOX_STYLE_TYPE["list"] = "list";
  PRODUCT_BOX_STYLE_TYPE["table"] = "table";
  PRODUCT_BOX_STYLE_TYPE["tile"] = "tile";
  return PRODUCT_BOX_STYLE_TYPE;
}(PRODUCT_BOX_STYLE_TYPE || {});
exports.PRODUCT_BOX_STYLE_TYPE = PRODUCT_BOX_STYLE_TYPE;
var ProductBox = function ProductBox(props) {
  var styleType = props.styleType;
  switch (styleType) {
    case PRODUCT_BOX_STYLE_TYPE.list:
      return /*#__PURE__*/_react["default"].createElement(_ProductBoxList.ProductBoxList, props);
    case PRODUCT_BOX_STYLE_TYPE.table:
      return /*#__PURE__*/_react["default"].createElement(_ProductBoxTable.ProductBoxTable, props);
    case PRODUCT_BOX_STYLE_TYPE.tile:
    default:
      return /*#__PURE__*/_react["default"].createElement(_ProductBoxTile.ProductBoxTile, props);
  }
};
exports.ProductBox = ProductBox;
ProductBox.ProductBoxList = _ProductBoxList.ProductBoxList;
ProductBox.ProductBoxTile = _ProductBoxTile.ProductBoxTile;
ProductBox.ProductBoxTable = _ProductBoxTable.ProductBoxTable;
ProductBox.config = {
  styleType: PRODUCT_BOX_STYLE_TYPE
};